import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';

const Layout = ({ children }) => {
  const [activeSection, setActiveSection] = useState('banner');
  const location = useLocation();
  const isSmartPage = location.pathname.startsWith('/smart-');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['banner', 'company-profile', 'solutions', 'advantages', 'footer'];
      const sectionElements = sections.map(id => ({
        id,
        element: document.querySelector(`.${id}`),
      }));

      const currentSection = sectionElements.find(({ element }) => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.top <= 100 && rect.bottom >= 100;
      });

      if (currentSection) {
        setActiveSection(currentSection.id);
      }
    };

    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [location]);

  useEffect(() => {
    if (isSmartPage) {
      setActiveSection('solutions');
    }
  }, [isSmartPage]);

  return (
    <div className="app">
      {/* 导航栏 */}
      <nav className="navbar">
        <div className="logo">
          <Link to="/">
            <img src="/src/img/xzclogo.png" alt="公司logo" />
          </Link>
        </div>
        <ul className="nav-links">
          <li 
            className={(!isSmartPage && activeSection === 'banner') ? 'active' : ''}
            onClick={() => {
              if (location.pathname === '/') {
                document.querySelector('.banner').scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/';
              }
            }}
          >网站首页</li>
          <li 
            className={(!isSmartPage && activeSection === 'company-profile') ? 'active' : ''}
            onClick={() => {
              if (location.pathname === '/') {
                document.querySelector('.company-profile').scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#company-profile';
              }
            }}
          >公司简介</li>
          <li 
            className={(isSmartPage || (!isSmartPage && activeSection === 'solutions')) ? 'active' : ''}
            onClick={() => {
              if (location.pathname === '/') {
                document.querySelector('.solutions').scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#solutions';
              }
            }}
          >解决方案</li>
          <li 
            className={(!isSmartPage && activeSection === 'advantages') ? 'active' : ''}
            onClick={() => {
              if (location.pathname === '/') {
                document.querySelector('.advantages').scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#advantages';
              }
            }}
          >产品优势</li>
          <li 
            className={(!isSmartPage && activeSection === 'footer') ? 'active' : ''}
            onClick={() => {
              if (location.pathname === '/') {
                document.querySelector('.footer').scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#footer';
              }
            }}
          >联系我们</li>
        </ul>
      </nav>

      {/* 页面内容 */}
      {children}

      {/* 页脚 */}
      <footer className="footer">
        <div className="contact-info">
          <p>公司地址：四川省成都市双流区富森美天府直播港14栋801</p>
          <p>联系电话：</p>
          <p>邮箱地址：</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;